import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectCookieConsent } from "redux/features/cookie/cookieConsentSlice"
import { CookieType } from "types"

export function withCookieConsent<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithCookieConsent = (props: GenericType) => {
    const consent = useAppSelector((state) =>
      selectCookieConsent(state),
    ) as CookieType
    const { cookie, session } = consent

    return <WrappedComponent {...props} cookie={cookie} session={session} />
  }

  return WithCookieConsent
}
